export default "__VITE_ASSET__tmaha0tg__"